<template>
  <table>
    <thead>
      <th
        v-for="(col, index) in columns"
        :key="`th${index}`"
      >{{ col }}</th>
    </thead>
    <tbody>
      <tr
        v-for="(row, rowindex) in catDataSorted"
        :key="`tr${rowindex}`">
        <td
          v-for="(col, colindex) in columns"
          :key="`td-${rowindex}-${colindex}`">{{ row[col] ? row[col] : '' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    catData: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    catDataSorted() {
      const { lku } = this.$store.state;
      // add sort columns, set to 0 if the corresponding column is missing (i.e. missing data rows won't have dvt, r, s1, etc.)
      const dataWithSortCols = _(this.catData).map(o => ({
        ...o,
        csort: lku.Category[o.c].sort,
        qsort: lku.Question[o.q].sort,
        dvtsort: o.dvt ? lku.DataValueType[o.dvt].sort : 0,
        rsort: o.r ? lku.Response[o.r].sort : 0,
        s1sort: o.s1 ? lku.Stratification[o.s1].sort : 0,
        colSort: o[this.$store.getters['CR/compareColumnsAlias']] ? lku[this.$store.getters['CR/compareColumnsLkuType']].sort : 0,
      }))
        .orderBy(
          ['csort', 'qsort', 'dvtsort', 'rsort', 's1sort', 'colsort'],
          ['asc', 'asc', 'asc', 'asc', 'asc', this.$store.getters['CR/compareColumnsSortOrder']],
        )
        .value();
        // return _(dataWithSortCols).map(o => _.pick(o, ['c', 'q', 'y', 'dvt', 'r', 's1', 'l', 'dv', 'lci', 'hci', 'wn', 'fs'])).value();
      return dataWithSortCols;
    },
    columns() {
      // table may be sparsely populated, so we need to inspect all rows
      // to get the full set of columns
      let columns = [];
      _(this.catData).each((obj) => {
        _(_.keys(obj)).each((key) => {
          // add key to columns if it is not already in columns
          if (_.indexOf(columns, key) === -1) columns = _.concat(columns, key);
        });
      });
      return columns;
    },
  },
};
</script>

<style scoped>
  table {
    border-collapse: collapse;
  }
  th, td {
    border: 1px solid black;
  }
</style>



// WEBPACK FOOTER //
// src/components/CR/CRDebugTable.vue